import React, { useState } from 'react';
import { logo, rightArrow, subMenuContact1, subMenuContact2, subMenuContact3, subMenuContact4, subMenuHome, subMenuPartners, subMenuProjects, subMenuServices } from '../../assets/images';
import { useTranslation } from 'react-i18next';
import { FiMenu, FiX } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';



const newsItems = [
  {
    id: 1,
    imgSrc: subMenuHome,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '15.04.2025',
  },
  {
    id: 2,
    imgSrc: subMenuPartners,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '12.04.2025',
  },
  {
    id: 3,
    imgSrc: subMenuProjects,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '10.04.2025',
  },
];


const Header = () => {

  const { t, i18n } = useTranslation();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();  
  const isActiveLink = (path) => location.pathname.startsWith(path);

  return (
    <> 
        <div className='md:max-w-container max-w-containerSm mx-auto h-[80px] flex justify-between text-white'> 
          <div className='flex items-center'>
            <a className='mx-auto' href='/'><img className='mx-auto w-[72px]' alt='logo' src={logo}></img></a>
          </div>
          <div className='flex justify-center items-center '>
          <nav className='hidden md:block'>
          <ul className="flex relative w-[675px]">
        <li className="relative group">
  <a href="/" className="py-7 px-3 font-medium group-hover:text-firstColor group-hover:bg-[white] transition-colors duration-200">Ana səhifə</a>
  <ul className="fixed left-0 top-[79px] w-full bg-white text-black shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity duration-200 z-50">
            <div className="w-full h-[370px] relative">
  {/* Arka plan katmanı - %30 yeşil, %70 beyaz */}
  <div className="absolute inset-0 flex">
    <div className="bg-[#01A396] w-[30vw]"></div>
    <div className="bg-white w-[70vw]"></div>
  </div>

  {/* İçerik katmanı - max-w-container ile ortalanmış */} 
  <div className="relative z-10 max-w-container mx-auto h-full flex justify-between">
    {/* Sol taraf içerik */} 
    <div className="w-[355px] text-white py-[34px]">
      <p className='text-[32px] font-medium'>ŞİRKƏT</p>
      <p className='mt-[24px]'>Akond müxtəlif sektorlar üzrə müştərilərin tələblərinə cavab vermək üçün yüksək keyfiyyətli həllər təqdim edərək mükəmməlliyə, innovasiyaya və davamlılığa sadiq olan tikinti şirkətidir.</p>
     <a href='/about'>
                       <div className='flex justify-between items-center w-[175px] mt-[54px] rounded-[12px] bg-[white] text-[#1C1C1C] px-5 h-[46px]'>
                          <p>Hamısına bax</p>
                          <img className='w-2' src={rightArrow}></img>
                        </div>
                       </a>
    </div>

    {/* Sağ taraf içerik */}
    <div className="w-[905px] flex py-[25px] pl-[32px] justify-end">
      <div className='mr-[78px] py-[32px] flex'>
  <div className='mr-[60px]'>
   <p className='text-[24px] font-medium'>Biz kimik</p>
   <a href='/about'><p className='mt-3'>Haqqımızda</p></a>
  </div>
  <div>
   <p className='text-[24px] font-medium'>SƏTƏM</p>
   <a href='/about'><p className='mt-3'>Keyfiyyət</p></a>
   <a href='/about'><p className='mt-3'>Sağlamlıq</p></a>
   <a href='/about'><p className='mt-3'>Əməyin Təhlükəsizliyi</p></a>
   <a href='/about'><p className='mt-3'>Ətraf Mühitin Mühafizəsi</p></a>
  </div>
  <div>
    
  </div>
      </div>
      <div className='w-[439px]'>
        <img src={subMenuHome}  className='w-full'></img>
      </div>
    </div>
  </div>
</div>


            </ul>
    </li>

          <li className="relative group">
            <a href="/services" className="py-7 px-3 font-medium group-hover:text-firstColor group-hover:bg-[white] transition-colors duration-200">Xidmətlər</a>
            <ul className="fixed left-0 top-[79px] w-full bg-white text-black shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity duration-200 z-50">
            <div className="w-full h-[370px] relative">
  {/* Arka plan katmanı - %30 yeşil, %70 beyaz */}
  <div className="absolute inset-0 flex">
    <div className="bg-[#01A396] w-[30vw]"></div>
    <div className="bg-white w-[70vw]"></div>
  </div>

  {/* İçerik katmanı - max-w-container ile ortalanmış */}
  <div className="relative z-10 max-w-container mx-auto h-full flex justify-between">
    {/* Sol taraf içerik */}
    <div className="w-[375px] text-white py-[34px]">
      <p className='text-[32px] font-medium'>XİDMƏTLƏR</p>
      <p className='mt-[24px]'>Biz tikinti layihəsinin idarə edilməsi xidmətlərini, o cümlədən planlaşdırma, dizayn, xərclərin idarə edilməsi, podratçıların satınalmaları, müqavilələrin idarə edilməsi, keyfiyyətə nəzarət və SƏTƏM idarəetməsi xidmətləri təqdim edirik.</p>
     <a href='/services'>
                       <div className='flex justify-between items-center w-[175px] mt-[54px] rounded-[12px] bg-[white] text-[#1C1C1C] px-5 h-[46px]'>
                          <p>Hamısına bax</p>
                          <img className='w-2' src={rightArrow}></img>
                        </div>
                       </a>
    </div>

    {/* Sağ taraf içerik */}
    <div className="w-[905px] flex py-[25px] pl-[32px]">
      <div className='mr-[78px] py-[32px] flex'>
  <div className='mr-[32px] w-[162px]'>
   <p className='text-[24px] font-medium'>Xidmətlər</p>
   <a href='/services/1'><p className='mt-3'>İsitmə</p></a>
   <a href='/services/2'><p className='mt-3'>Ventilyasiya</p></a>
   <a href='/services/3'><p className='mt-3'>Soyutma, 
   kondisionerləşdirmə</p></a>
   <a href='/services/4'><p className='mt-3'>Santexnika</p></a>
   <a href='/services/5'><p className='mt-3'>Yanğınsöndürmə</p></a>
  </div>
  <div className='py-[36px]'>
   <a href='/services/6'><p className='mt-3'>Elektrik sistemləri</p></a>
   <a href='/services/7'><p className='mt-3'>Aşağı cərəyan</p></a>
   <a href='/services/8'><p className='mt-3'>Avtomatlaşdırma sistemləri</p></a>
   <a href='/services/9'><p className='mt-3'>Kanal sexi</p></a>
  </div>
  <div>
    
  </div>
      </div>
      <div className='w-[439px]'>
        <img src={subMenuServices}  className='w-full'></img>
      </div>
    </div>
  </div>
</div>


            </ul>
          </li>
          <li className="relative group">
            <a href="/projects" className="py-7 px-3 font-medium group-hover:text-firstColor group-hover:bg-[white] transition-colors duration-200">Layihələr</a>
            <ul className="fixed left-0 top-[79px] w-full bg-white text-black shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity duration-200 z-50">
            <div className="w-full h-[370px] relative">
  {/* Arka plan katmanı - %30 yeşil, %70 beyaz */}
  <div className="absolute inset-0 flex">
    <div className="bg-[#01A396] w-[30vw]"></div>
    <div className="bg-white w-[70vw]"></div>
  </div>

  {/* İçerik katmanı - max-w-container ile ortalanmış */}
  <div className="relative z-10 max-w-container mx-auto h-full flex justify-between">
    {/* Sol taraf içerik */}
    <div className="w-[375px] text-white py-[34px]">
      <p className='text-[32px] font-medium'>LAYİHƏLƏR</p>
      <p className='mt-[24px]'>İnnovasiyaya təkan verən və davamlı müsbət təsir yaradan dayanıqlı tikinti layihələrimiz vasitəsilə uzaqgörən ideyaların necə reallığa çevrildiyini kəşf edin.</p>
     <a href='/projects'>
                       <div className='flex justify-between items-center w-[175px] mt-[54px] rounded-[12px] bg-[white] text-[#1C1C1C] px-5 h-[46px]'>
                          <p>Hamısına bax</p>
                          <img className='w-2' src={rightArrow}></img>
                        </div>
                       </a>
    </div>

    {/* Sağ taraf içerik */}
    <div className="w-[905px] flex py-[25px] pl-[32px]">
      <div className='mr-[335px] py-[32px] flex'>
  <div className='mr-[32px] w-[119px]'>
   <p className='text-[24px] font-medium'>Layihələr</p>
   <a href='/projects'><p className='mt-3'>Bütün layihələr</p></a>
   <a href='/projects?filter=Davam+edən'><p className='mt-3'>Davam edən</p></a>
   <a href='/projects?filter=Tamamlanmış'><p className='mt-3'>Tamamlanmış</p></a>
  </div>
  <div>
    
  </div>
      </div>
      <div className='w-[439px]'>
        <img src={subMenuProjects}  className='w-full'></img>
      </div>
    </div>
  </div>
</div>


            </ul>
          </li>

          <li className="relative group">
            <a href="/partners" className="py-7 px-3 font-medium group-hover:text-firstColor group-hover:bg-[white] transition-colors duration-200">Tərəfdaşlıq</a>
            <ul className="fixed left-0 top-[79px] w-full bg-white text-black shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity duration-200 z-50">
            <div className="w-full h-[370px] relative">
  {/* Arka plan katmanı - %30 yeşil, %70 beyaz */}
  <div className="absolute inset-0 flex">
    <div className="bg-[#01A396] w-[30vw]"></div>
    <div className="bg-white w-[70vw]"></div>
  </div>

  {/* İçerik katmanı - max-w-container ile ortalanmış */}
  <div className="relative z-10 max-w-container mx-auto h-full flex justify-between">
    {/* Sol taraf içerik */}
    <div className="w-[375px] text-white py-[34px]">
      <p className='text-[32px] font-medium'>TƏRƏFDAŞLIQ</p>
      <p className='mt-[24px]'>Aparıcı təşkilatlarla əməkdaşlığımız tikintidə innovasiyalara və mükəmməlliyə sadiqliyimizi gücləndirir, bizə yeni sənaye standartlarını təyin etməyə və cəmiyyətə müsbət töhfə verməyə kömək edir.</p>
     <a href='/partners'>
                       <div className='flex justify-between items-center w-[175px] mt-[54px] rounded-[12px] bg-[white] text-[#1C1C1C] px-5 h-[46px]'>
                          <p>Hamısına bax</p>
                          <img className='w-2' src={rightArrow}></img>
                        </div>
                       </a>
    </div>

    {/* Sağ taraf içerik */}
    <div className="w-[905px] flex py-[25px] pl-[32px]">
      <div className='mr-[335px] py-[32px] flex'>
  <div className='mr-[32px] w-[119px]'>
   <p className='text-[24px] font-medium'>Tərəfdaşlıq</p>
   <a href='/partners'><p className='mt-3'>Tərəfdaşlar</p></a>
  </div>
  <div>
    
  </div>
      </div>
      <div className='w-[439px]'>
        <img src={subMenuPartners}  className='w-full'></img>
      </div>
    </div>
  </div>
</div>


            </ul>
          </li>

          <li className="relative group">
            <a href="/news" className="py-7 px-3 font-medium group-hover:text-firstColor group-hover:bg-[white] transition-colors duration-200">Xəbərlər</a>
            <ul className="fixed left-0 top-[79px] w-full bg-white text-black shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity duration-200 z-50">
            <div className="w-full h-[370px] relative">
  {/* Arka plan katmanı - %30 yeşil, %70 beyaz */}
  <div className="absolute inset-0 flex">
    <div className="bg-[#01A396] w-[30vw]"></div>
    <div className="bg-white w-[70vw]"></div>
  </div>

  {/* İçerik katmanı - max-w-container ile ortalanmış */}
  <div className="relative z-10 max-w-container mx-auto h-full flex justify-between">
    {/* Sol taraf içerik */}
    <div className="w-[375px] text-white py-[34px]">
      <p className='text-[32px] font-medium'>XƏBƏRLƏR</p>
      <p className='mt-[24px]'>Akondda baş verən son xəbərlərdən məlumatlı qalın. Tikinti və inşaat sektorunda baş verən ən son yenilikləri bizimlə öyrənin.</p>
     <a href='/news'>
                       <div className='flex justify-between items-center w-[175px] mt-[54px] rounded-[12px] bg-[white] text-[#1C1C1C] px-5 h-[46px]'>
                          <p>Hamısına bax</p>
                          <img className='w-2' src={rightArrow}></img>
                        </div>
                       </a>
    </div>

    {/* Sağ taraf içerik */}
    <div className="w-[905px] flex py-[25px] pl-[32px]">
    <div className='w-full py-[44px] grid grid-cols-3 gap-5'>
    {newsItems.map((item) => (
      <a key={item.id} href={`/news/${item.id}`}>
        <div className='w-[270px]'>
          <div className="relative">
            <img src={item.imgSrc} className='w-full' alt='' />
            <span className='absolute top-3 right-3 text-[#008A7F] bg-[#F6FAFA] text-[12px] h-[21px] w-[83px] rounded-[12px] text-center flex items-center justify-center'>
              {item.date}
            </span>
          </div>
          <p className='mt-3 text-[#1C1C1C]'>{item.title}</p>
        </div>
      </a>
    ))}
  </div>
    </div>
  </div>
</div>


            </ul>
          </li>

          <li className="relative group">
            <a href="/careers" className="py-7 px-3 font-medium group-hover:text-firstColor group-hover:bg-[white] transition-colors duration-200">Karyera</a>
            <ul className="fixed left-0 top-[79px] w-full bg-white text-black shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity duration-200 z-50">
            <div className="w-full h-[370px] relative">
  {/* Arka plan katmanı - %30 yeşil, %70 beyaz */}
  <div className="absolute inset-0 flex">
    <div className="bg-[#01A396] w-[30vw]"></div>
    <div className="bg-white w-[70vw]"></div>
  </div>

  {/* İçerik katmanı - max-w-container ile ortalanmış */}
  <div className="relative z-10 max-w-container mx-auto h-full flex justify-between">
    {/* Sol taraf içerik */}
    <div className="w-[375px] text-white py-[34px]">
      <p className='text-[32px] font-medium'>KARYERA</p>
      <p className='mt-[24px]'>Aparıcı təşkilatlarla əməkdaşlığımız tikintidə innovasiyalara və mükəmməlliyə sadiqliyimizi gücləndirir, bizə yeni sənaye standartlarını təyin etməyə və cəmiyyətə müsbət töhfə verməyə kömək edir.</p>
     <a href='/careers'>
                       <div className='flex justify-between items-center w-[175px] mt-[54px] rounded-[12px] bg-[white] text-[#1C1C1C] px-5 h-[46px]'>
                          <p>Hamısına bax</p>
                          <img className='w-2' src={rightArrow}></img>
                        </div>
                       </a>
    </div>

    {/* Sağ taraf içerik */}
    <div className="w-[905px] flex py-[25px] pl-[32px]">
      <div className='mr-[96px] py-[32px] flex'>
  <div className='mr-[32px] w-[358px]'>
   <p className='text-[24px] font-medium'>Karyera</p>
   <a href='/careers-resource'><p className='mt-3'>İnsan Resursları</p></a>
   <a href='/careers-life'><p className='mt-3'>Akondda həyat</p></a>
   <a href='/careers-starters'><p className='mt-3'>Tələbələr və Başlanğıc Səviyyə Mütəxəssisləri</p></a>
   <a href='/careers-professionals'><p className='mt-3'>Təcrübəli Mütəxəssislər</p></a>
   <a href='/careers-jobs'><p className='mt-3'>Vakansiyalarımız</p></a>
  </div>
  <div>
    
  </div>
      </div>
      <div className='w-[439px]'>
        <img src={subMenuPartners}  className='w-full'></img>
      </div>
    </div>
  </div>
</div>


            </ul>
          </li>
          <li className="relative group">
            <a href="/contact" className="py-7 px-3 font-medium group-hover:text-firstColor group-hover:bg-[white] transition-colors duration-200">Əlaqə</a>
            <ul className="fixed left-0 top-[79px] w-full bg-white text-black shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity duration-200 z-50">
            <div className="w-full h-[370px] relative">
  {/* Arka plan katmanı - %30 yeşil, %70 beyaz */}
  <div className="absolute inset-0 flex">
    <div className="bg-[#01A396] w-[30vw]"></div>
    <div className="bg-white w-[70vw]"></div>
  </div>

  {/* İçerik katmanı - max-w-container ile ortalanmış */}
  <div className="relative z-10 max-w-container mx-auto h-full flex justify-between">
    {/* Sol taraf içerik */}
    <div className="w-[375px] text-white py-[34px]">
      <p className='text-[32px] font-medium'>ƏLAQƏ</p>
      <p className='mt-[24px]'>Sorğularınızla bağlı bizimlə əlaqə saxlaya bilərsiniz. Komandamız sizə lazım olan dəstəyi və məlumatı təmin etmək üçün xidmətinizdədir.</p>
     <a href='/contact'>
                       <div className='flex justify-between items-center w-[175px] mt-[54px] rounded-[12px] bg-[white] text-[#1C1C1C] px-5 h-[46px]'>
                          <p>Hamısına bax</p>
                          <img className='w-2' src={rightArrow}></img>
                        </div>
                       </a>
    </div>

    {/* Sağ taraf içerik */}
    <div className="w-[905px] flex py-[25px] pl-[32px]">
      <div className='mr-[90px] py-[32px] flex'>
  <div className='mr-[32px] w-[364px]'>
   <p className='text-[24px] font-medium'>Əlaqə</p>
   <div className='flex gap-2 mt-3'>
    <img className='h-6 w-6' src={subMenuContact2}></img>
   <p className='text-[18px] font-medium text-[#1C1C1C]'>Ünvan</p>
   </div>
   <p className='mt-3 text-[#1C1C1C]'>Babək prospekti 38a AZ1074
   Bakı/Azərbaycan</p>
   <div className='flex gap-2 mt-3'>
    <img className='h-6 w-6' src={subMenuContact3}></img>
   <p className='text-[18px] font-medium text-[#1C1C1C]'>E-poçt</p>
   </div>
   <p className='mt-3 text-[#1C1C1C]'>info@akond.az</p>
   <div className='flex gap-2 mt-3'>
    <img className='h-6 w-6' src={subMenuContact4}></img>
   <p className='text-[18px] font-medium text-[#1C1C1C]'>Əlaqə nömrəsi</p>
   </div>
   <p className='mt-3 text-[#1C1C1C]'>012 424 34 55</p>
   <p className='mt-2 text-[#1C1C1C]'>012 424 34 56</p>
  </div>
  <div>
    
  </div>
      </div>
      <div className='w-[439px]'>
        <img src={subMenuContact1}  className='w-full'></img>
      </div>
    </div>
  </div>
</div>


            </ul>
          </li>
        </ul>
</nav>
<button
            className="lg:hidden text-gray-700 mt-4"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <FiX size={28} color="#fff" /> : <FiMenu color="#fff" size={24} />}
          </button>
          {isMobileMenuOpen && ( 
             <div
             className={`fixed inset-0 bg-white text-black z-50 transform ${
               isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
             } transition-transform duration-300 ease-in-out`}
           >
             <div className="max-w-containerSm mx-auto pt-8 flex flex-col h-full">
               {/* Kapatma Butonu */}
               <div className="flex justify-between">
                 <img className="h-[59px]" src={logo}></img>
                 <button onClick={() => setIsMobileMenuOpen(false)}>
                   <FiX size={32} />
                 </button>
               </div>
     
               {/* Menü İçeriği */}
               <nav className="mt-10">
                 {[
                   { path: "/", label: "Ana səhifə" },
                   { path: "/about", label: "Haqqımızda" },
                   { path: "/services", label: "Xidmətlər" },
                   { path: "/projects", label: "Layihələr" },
                   { path: "/partners", label: "Tərəfdaşlıq" },
                   { path: "/news", label: "Xəbərlər" },
                   { path: "/careers", label: "Karyera" },
                   { path: "/contact", label: "Əlaqə" },
                   { path: "/subpodrat", label: "Subpodratçı olun" },
                 ].map((item, index) => (
                   <a
                   key={index}
                   href={item.path}
                   className={`block text-lg py-3 rounded-lg transition ${
                     isActiveLink(item.path) ? "text-firstColor font-medium" : "text-black"
                   }`}
                 >
                   {t(item.label)}
                 </a>
                 ))}
               </nav>
             </div>
           </div>
          )}

          </div>
        </div>
    </>
  );
};

export default Header;






